var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.38,
    height: 21.62,
    viewBox: "0 0 19.38 21.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONOS_FLUJO",
    "data-name": "ICONOS FLUJO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Process",
    "data-name": " Process"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.66,15.49a2.12,2.12,0,0,1-.1.36,4.93,4.93,0,0,1-.43.74,2.14,2.14,0,0,1-1.44.88l-.23,0c-.14,0-.18.09-.12.2a2.35,2.35,0,0,1,.24.82,2.11,2.11,0,0,1-.27,1.25c-.09.17-.19.34-.29.51a.87.87,0,0,1-1.21.32c-.87-.49-1.73-1-2.59-1.49a.86.86,0,0,1-.33-1.22,4.07,4.07,0,0,1,.58-.9,2.25,2.25,0,0,1,1.47-.66c.15,0,.19-.08.12-.22a2.09,2.09,0,0,1-.1-1.76,4.56,4.56,0,0,1,.52-.91.85.85,0,0,1,1.16-.19l1.79,1,.77.44A1,1,0,0,1,19.66,15.49ZM13.5,18.35a.88.88,0,0,0,.15.12L16,19.83c.32.19.3.2.49-.14a2.69,2.69,0,0,0,.28-.53,1.49,1.49,0,0,0-.1-1.15,1.14,1.14,0,0,1-.1-.36.88.88,0,0,1,.83-.91A1.42,1.42,0,0,0,18.62,16c.07-.14.14-.26.22-.39s.07-.19-.08-.27L16.36,14c-.25-.14-.25-.15-.39.1a3.17,3.17,0,0,0-.32.6,1.41,1.41,0,0,0,.1,1.15.86.86,0,0,1-.61,1.25c-.11,0-.23,0-.35.05a1.36,1.36,0,0,0-.9.56,6.48,6.48,0,0,0-.33.57A1.3,1.3,0,0,0,13.5,18.35Z",
    transform: "translate(-2.52 -0.98)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.55,20.13H19a.37.37,0,0,1-.36-.29.36.36,0,0,1,.2-.42l.18,0h1.39a.38.38,0,0,1,.39.4v1.37a.37.37,0,0,1-.38.4.38.38,0,0,1-.37-.4v-.46c-.19.16-.37.33-.55.47a5.23,5.23,0,0,1-4,1.1,5.37,5.37,0,0,1-4.62-4.46c0-.27-.05-.56-.07-.84a.38.38,0,1,1,.75,0,4.38,4.38,0,0,0,.49,2,4.65,4.65,0,0,0,7.42,1.23Z",
    transform: "translate(-2.52 -0.98)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.86,13.69h.47a.38.38,0,1,1,0,.75H12a.38.38,0,0,1-.4-.41V12.68a.37.37,0,0,1,.37-.41.38.38,0,0,1,.38.41v.47a1.13,1.13,0,0,0,.11-.11,5.4,5.4,0,0,1,9,2.61,4.85,4.85,0,0,1,.15,1.19c0,.27-.14.44-.37.44a.37.37,0,0,1-.38-.42,4.65,4.65,0,0,0-5.12-4.57A4.52,4.52,0,0,0,13,13.59Z",
    transform: "translate(-2.52 -0.98)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "lineas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.82,8.84H6.14c-.07,0-.17,0-.22,0s-.2-.2-.2-.31.12-.22.21-.3.13,0,.2,0H13.7a.28.28,0,0,1,.24.31.3.3,0,0,1-.25.33H9.82Z",
    transform: "translate(-2.52 -0.98)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68,6.39H6.31c-.42,0-.66-.15-.63-.41S6,5.6,6.3,5.6c2.26,0,4.51,0,6.76,0,.43,0,.64.15.62.41s-.29.39-.62.38Z",
    transform: "translate(-2.52 -0.98)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69,11.77H5.93s-.09,0-.11,0a1.18,1.18,0,0,1-.1-.39,1.12,1.12,0,0,1,.1-.38c0-.05.07,0,.1,0H9.56c.07,0,.12.15.12.38s0,.38-.12.41-.06,0-.09,0Z",
    transform: "translate(-2.52 -0.98)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.22,5.48h2a.7.7,0,1,1,0,1.4h-2.7a.71.71,0,0,1-.7-.8V2.78a.63.63,0,0,1,.7-.7.68.68,0,0,1,.7.7v2.7Z",
    transform: "translate(-2.52 -0.98)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.16,1a7,7,0,0,1,.95,0,7,7,0,0,1,3.72,1.37c1.79,1.47,2,3.89,2.11,5.78a13,13,0,0,1-.07,2.53.64.64,0,1,1-1.25,0v-2c0-4.6-1.4-6.2-5.3-6.2H9.12c-3.9,0-5.3,1.6-5.3,6.2v6c0,4.6,1.4,6.3,5.3,6.3h1.7c.3,0,.6.3.6.8s-.3.8-.6.8H9.12c-4.6,0-6.6-2.3-6.6-7.8v-6c0-5.4,2-7.7,6.6-7.7C9.42,1.08,11,1,14.16,1Z",
    transform: "translate(-2.52 -0.98)",
    fill: "{props.color}"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.46,22",
    transform: "translate(-2.52 -0.98)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88,17.54",
    transform: "translate(-2.52 -0.98)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.a30e86da15b010eee43a6d6076097260.svg";
export { ForwardRef as ReactComponent };